export class TakenListQuery {
    constructor(public ScID?, public DID?, public Period?, public JT?, public FromDate?, public ToDate?) { }
}